import { Fragment, useEffect, useState } from "react";

import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Paginator } from "primereact/paginator";

import { TemplateInvoiceService as Service } from "../../../service/invoice/TemplateInvoiceService";
import { TypeInvoiceService } from "../../../service/invoice/TypeInvoiceService";

export const Create = () => {
  const [invoiceTypes, setInvoiceTypes] = useState([]);

  const [invoiceType, setInvoiceType] = useState(null);
  const [code, setCode] = useState("");
  const [pageSize, setPageSize] = useState("A4");

  const pageSizes = [
    { value: "A4", label: "A4" },
    { value: "A5", label: "A5" },
    { value: "A6", label: "A6" },
    { value: "A7", label: "A7" },
  ];

  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(4);

  const [totalRecords, setTotalRecords] = useState(0);
  const [items, setItems] = useState([]);

  useEffect(() => {
    // TypeInvoiceService.getList({}).then(({ items }) => {
    //   if (items) {
    //     const _invoiceTypes = [{ value: null, label: "- Tất cả -" }];
    //     items.forEach((item) => {
    //       _invoiceTypes.push({ value: item.id, label: item.name });
    //     });
    //     setInvoiceTypes(_invoiceTypes);
    //     setInvoiceType(_invoiceTypes[1].value);
    //   }
    // });
    var _invoiceTypes = [
      {
        code: "HDGTGT",
        created: null,
        creationTime: "2022-02-02T00:00:00+07:00",
        creatorId: null,
        deleterId: null,
        deletionTime: null,
        id: "fc057613-9499-47f0-bbeb-2181c254c159",
        isDeleted: false,
        lastModificationTime: null,
        lastModifierId: null,
        name: "Hóa đơn giá trị gia tăng",
        reportName: "HDGTGT",
        type: 1,
      },
    ];
    setInvoiceTypes(_invoiceTypes);
    setInvoiceType(_invoiceTypes[0].id);
  }, []);

  useEffect(() => {
    loadTemplate();
  }, [first, rows, invoiceType]); // eslint-disable-line react-hooks/exhaustive-deps

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const loadTemplate = () => {
    Service.getList({
      maxResultCount: rows,
      skipCount: first,
      typeInvoiceId: invoiceType,
      code,
      pageSize,
      sorting: 'code',
      sortType: 'ASCEND'
    }).then(({totalCount, items}) => {
      setTotalRecords(totalCount);
      setItems(items);
    });
  };

  const back = () => {
    window.location.hash = "/phat-hanh/mau-hoa-don";
  };

  const windowHeight = window.innerHeight;

  return (
    <div className="mt-1 pl-3 pr-3 pt-2">
      <div
        className="grid iam-scroll"
        style={{ height: windowHeight - 200 + "px", overflow: "hidden auto" }}
      >
        {/* <div className="col-12 md:col-4">
          <div className="field p-fluid">
            <Dropdown
              value={invoiceType}
              options={invoiceTypes}
              onChange={(e) => setInvoiceType(e.value)}
              placeholder="Loại hoá đơn"
            />
          </div>
        </div>
        <div className="col-12 md:col-3">
          <div className="field p-fluid">
            <InputText
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Mã mẫu hoá đơn"
            />
          </div>
        </div>
        <div className="col-12 md:col-2">
          <div className="field p-fluid">
            <Dropdown
              value={pageSize}
              options={pageSizes}
              onChange={(e) => setPageSize(e.value)}
              placeholder="Khổ giấy"
            />
          </div>
        </div> */}
        {/* <div className="col-12 md:col-1">
          <div className="field p-fluid">
            <Button icon="pi pi-search" onClick={loadTemplate} />
          </div>
        </div> */}

        {items.map((item, index) => {
          return (
            <div key={index} className="col-12 md:col-3 template-image-preview">
              <div className="card h-full">
                <div>
                  <b>{item.code}</b>
                </div>
                <Preview id={item.id} invoiceType={invoiceType} />
              </div>
            </div>
          );
        })}
      </div>
      <div className="grid p-3 pb-0 card pt-0 mt-2">
        <div className="col-2 pt-4">
          <Button
            label="Quay lại"
            icon="pi pi-arrow-left"
            onClick={back}
            className="p-button-outlined p-button-secondary p-button-sm"
          />
        </div>
        <div className="col-8">
          <Paginator
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            rowsPerPageOptions={[4, 8, 12]}
            onPageChange={onPageChange}
          />
        </div>
        <div className="col-2 pt-5 text-right">
          Tổng số {totalRecords} bản ghi
        </div>
      </div>
    </div>
  );
};

const Preview = ({ id, invoiceType }) => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    if (id) {
      Service.get(id).then((data) => {
        if (data && data.imageContent) {
          setContent(data.imageContent);
        } else {
          setContent(null);
        }
      });
    } else {
      setContent(null);
    }
  }, [id]);

  const select = () => {
    if (id) {
      window.location.hash = `/phat-hanh/mau-hoa-don/create/${id}?invoiceType=${invoiceType}`;
    }
  };

  return (
    <Fragment>
      <div onClick={select}>
        {!content && <i className="pi pi-image" />}
        {content && <img src={`data:image/png;base64,${content}`} alt="" />}
      </div>
    </Fragment>
  );
};
